import React from 'react';

import { Button } from 'ui/component';
import classNames from './EABD2CaseContactUs.module.scss';

export interface CaseContactUsProps
  extends Readonly<{
    text: string;
    buttonText: string;
    onButtonPress: () => void;
  }> {}

export const CaseContactUs = React.memo<CaseContactUsProps>((props) => {
  const { text, buttonText, onButtonPress } = props;

  return (
    <div className={classNames.root}>
      <div className={classNames.textWrapper}>
        <p className={classNames.text}>{text}</p>
      </div>
      <Button text={buttonText} onPress={onButtonPress} />
    </div>
  );
});
